import { render, staticRenderFns } from "./SubPOInStock.vue?vue&type=template&id=2d7857cf&scoped=true&"
import script from "./SubPOInStock.vue?vue&type=script&lang=js&"
export * from "./SubPOInStock.vue?vue&type=script&lang=js&"
import style0 from "./SubPOInStock.vue?vue&type=style&index=0&id=2d7857cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7857cf",
  null
  
)

export default component.exports